import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Equipo',
    href: '#equipo'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-night-900/80 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-63">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-64">
        <a href="#" className="text-gold font-serif text-2xl md:text-3xl font-bold tracking-widest" data-id="element-65">
          LUMIÈRE{' '}
          <span className="text-pearl font-light text-xl md:text-2xl" data-id="element-66">
            DENTAL
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-67">
          <div className="flex space-x-6" data-id="element-68">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-pearl/80 hover:text-gold transition-colors text-sm uppercase tracking-widest font-medium" data-id="element-69">
                {link.name}
              </a>)}
          </div>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-gold text-night-900 px-6 py-3 rounded-sm font-semibold text-sm uppercase tracking-wider hover:bg-gold-light transition-colors" data-id="element-70">
            Reservar Sesión VIP
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-gold" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-71">
          {isMobileMenuOpen ? <X size={28} data-id="element-72" /> : <Menu size={28} data-id="element-73" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} className="md:hidden bg-night-900 border-t border-night-800 mt-4" data-id="element-74">
          <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-75">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-pearl hover:text-gold transition-colors text-lg uppercase tracking-widest py-2" data-id="element-76">
                {link.name}
              </a>)}
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-gold text-night-900 px-6 py-4 rounded-sm font-semibold text-center uppercase tracking-wider mt-4" data-id="element-77">
              Reservar Sesión VIP
            </a>
          </div>
        </motion.div>}
    </motion.nav>;
}